import { MappingFormValues } from 'pages/GatewayRules/components/GatewayRulesForm/hooks/useGatewayRulesForm';
import { getInitialMappingItem } from 'pages/GatewayRules/components/GatewayRulesForm/utils/getInitialMappingItem';

export function getInitialMapping(): Nullable<MappingFormValues> {
  return {
    active: true,
    direction: null,
    method: null,
    mappingItems: [getInitialMappingItem()],
  } as any;
}
